import ModuleTable from "./moduleTable.container";

export default ModuleTable;
